import React, { Component, PropTypes } from 'react'

import { filterObject, getProperty, normaliseMap } from '../utils'
import { Loading } from '../misc'
import { Label, MultipleYesNo } from '../ui'

export default class Software extends Component {
    static propTypes = {
        crewType: PropTypes.string.isRequired,
        crew_uuid: PropTypes.string.isRequired,
        data: PropTypes.object.isRequired,
        gear: PropTypes.object.isRequired,
        gearActions: PropTypes.object.isRequired,
        type: PropTypes.string.isRequired,
        updateValue: PropTypes.func.isRequired,
    }

    componentWillMount() {
        if (! this._getSoftwareOptions()) {
            this.props.gearActions.loadSoftwareOptions()
        }
    }

    _getSoftwareOptions() {
        return getProperty(this.props.gear, `software_options.${ this.props.type }`)
    }

    _updateValueAndSendPatchRequest = (data) => {
        // okay let's clean the data up before we send it, just to ensure that we send only the data we care about
        const software_map = {}

        const options = this._getSoftwareOptions().map((item) => item.uuid)

        // go through each item being submitted and just check that the key (uuid of editing software option) actually
        // exists in the options we are actually displaying
        for (const key in data.software_map) {
            if (options.includes(key)) {
                software_map[key] = data.software_map[key]
            }
        }

        const newData = { software_map }

        this.props.updateValue(newData)
        this._sendPatchRequest(newData)
    }

    _sendPatchRequest = (data = this.props.data) => {
        const newData = filterObject(
            data,
            [ 'software_map' ],
        )

        this.props.gearActions.patchGear(newData, this.props.crew_uuid, this.props.crewType)
    }

    _softwareTypeName(type) {
        switch (type) {
            case 'editing':
                return 'Editing'
            case 'color':
                return 'Editing & Color'
            case 'audio':
                return ''
        }

        return ''
    }

    render() {
        // if no editing software options exist, don't even show
        if (! this._getSoftwareOptions()) {
            return null
        }

        // if we don't have any data yet, just say we're loading
        if (! this.props.data) {
            return <Loading />
        }

        const errors = this.props.gear.errors

        return (
            <div className="content__inner">
                <div className="box">
                    <div className="box__header">
                        <div className="box__title">
                            { this._softwareTypeName(this.props.type) } Software
                        </div>
                    </div>
                    <div className="box__content box__content--padded">
                        <Label>Are you proficient in:</Label>

                        <MultipleYesNo
                            error={ errors.software_map }
                            name="software_map"
                            options={ normaliseMap(this._getSoftwareOptions()) }
                            updateValue={ this._updateValueAndSendPatchRequest }
                            value={ getProperty(this.props.data, 'software_map') }
                        />
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/components/gear/software.js